/*
 * @Author: daiqi@sogou-inc.com
 * @Date: 2022-02-28 12:15:39
 * @Description: 列表页
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    config: { uuid: '' },
    searchData: {},
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_LIST_RESULT](state, searchData) {
      state.searchData = searchData;
    },
    [types.UPDATE_LIST_CONFIG](state, config) {
      state.config = config;
    },
  },
  actions: {
    /**
      * 获取列表页数据
      */
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, { routeName: route.name }, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/classlist`,
        params,
        timeout: 4500,
      });
      result = result && result.data;
      const { status } = result || {};
      if (status === 301) {
        return result;
      }
      if (status === 0) {
        const { head = '', listData, config, loadingFinished } = result;
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_LIST_RESULT, listData);
        commit(types.UPDATE_LIST_CONFIG, config);
        commit(
          `common/${types.UPDATE_LOADING_FINISHED}`,
          loadingFinished,
          { root: true },
        );
        return result;
      }
      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
